import { useCallback, useMemo } from "react";
import { toast } from "react-toastify";
import IGeoCoordinate from "../interfaces/IGeoCoordinate";
import ParcelApiService from "../services/parcelApiService";
import useNavigateToInsights from "./useNavigateToInsights";

export default function useNavigateToCountyInsights(): (county: string, centerPoint: IGeoCoordinate) => Promise<void> {
    const navigateToInsights = useNavigateToInsights();
    const parcelApiService = useMemo(() => new ParcelApiService(), []);

    return useCallback(async (county: string, centerPoint: IGeoCoordinate) => {
        const shape = await parcelApiService.getCountyShapeFeature(centerPoint).catch(() => null);
        if (!shape) {
            toast.error(`The county shape for ${county} is not found`);
            return;
        }

        navigateToInsights(shape);
    }, []);
}
